import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import { MutationError } from '../types';
import { HttpQuery } from '../types/http';
import {
  createCoSignerRequest,
  getCoSignerRequestsAndApplicantInfo,
} from '../http/coSignerRequests';
import { CoSignerRequest } from '../types/coSignerRequests';
import { toast } from 'react-toastify';
import { DealApplicantInfo } from '../types/applicants';

export const useGetCoSignerRequestsAndApplicantInfo = (query?: HttpQuery) => {
  const queryKey = ['mainApplicantInfo'];

  const { data, isLoading, error, refetch } = useQuery<
    {
      coSignerRequests: CoSignerRequest[];
      applicantInfo: DealApplicantInfo;
      names: string;
    },
    MutationError,
    {
      coSignerRequests: CoSignerRequest[];
      applicantInfo: DealApplicantInfo;
      names: string;
    }
  >({
    queryKey: queryKey,
    queryFn: getCoSignerRequestsAndApplicantInfo(query),
  });

  return {
    data,
    refetch,
    isLoading,
    error,
  };
};

export const useCreateCoSignerRequest = (
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
  ) => Promise<
    QueryObserverResult<
      {
        coSignerRequests: CoSignerRequest[];
        applicantInfo: DealApplicantInfo;
        names: string;
      },
      MutationError
    >
  >
) => {
  const mutation = useMutation<
    CoSignerRequest,
    MutationError,
    {
      applicantInfo: DealApplicantInfo;
      coSignerRequestId?: string;
      dealId: string;
      token: string | null;
    }
  >(createCoSignerRequest(), {
    onSuccess: () => {
      toast.success('Successfully submitted co-signer request.', {
        position: 'top-center',
      });
      refetch();
    },
  });
  return {
    createCoSignerRequest: mutation.mutate,
    loading: mutation.isLoading,
    success: mutation.isSuccess,
    error: mutation.error,
  };
};
